module.exports = '<!DOCTYPE html>\n<div class="md-caption" role="alert" ng-show="field.error">\n  {{ field.error.message }}\n</div>\n';